import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: max-content;
  padding: 80px;

  h2 {
    color: ${({ theme }) => theme.colors.outher.danger};
  }

  a {
    margin-top: 40px;
    text-decoration: underline;
  }
`;
